<script setup>
import requests from "@/OfOnboardingRequests";
import { toaster } from "@dk.onlinefundraising/vue-utils/src/helpers/OfToaster";
import OfButton from "@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue";
import OfModalBlock from "@dk.onlinefundraising/vue-utils/src/utils/OfModalBlock.vue";
import OfSubModal from "@dk.onlinefundraising/vue-utils/src/utils/OfSubModal.vue";
import { ref, defineEmits } from "vue";

const emit = defineEmits(['close', 'getMerchants']);

const token = ref('');

function addMerchantLicense() {
    requests.addMerchantLicense(token.value).then((result) => {
        if (result && result.token) {
            toaster.success('Access gained')
            emit('getMerchants');
            emit('close');
        }
    })
}
</script>
<template>
    <OfSubModal passive @close="emit('close')">

        <template #heading>Add client</template>

        <template #content>
            <OfModalBlock>

                <template #block-header>

                    <h4>Insert access token</h4>

                    <small class="input-helper-text">
                        Please contact your client for an access token
                    </small>

                </template>

                <template #block-content>

                    <div class="checkform">

                        <div class="checkform-token">
                            <input v-model="token" type="text" placeholder="Insert token">
                        </div>

                        <div class="checkform-submit">

                            <OfButton size="large" text="Submit token" coloring="primary" @click="addMerchantLicense" />

                        </div>

                    </div>

                    <h5>
                        What happens next?
                    </h5>

                    <small class="input-helper-text">
                        Once confirmed you will gain access to the client's campaigns and workflows.
                    </small>

                </template>
            </OfModalBlock>
        </template>

    </OfSubModal>
</template>
<style scoped>
.checkform {
    display: flex;
    flex-flow: row;
    position: relative;
    align-items: center;
    margin-bottom: 1rem;
}

.checkform-token {
    flex: 1 1 80%;
    position: relative;
}

.checkform-token>input {
    height: 56px;
    border-radius: 0;
}

.checkform-submit {
    flex: 1 1 auto;
    font-weight: 500;
    font-family: Roboto, sans-serif;
}

.checkform-submit>:deep(button) {
    height: 56px;
    min-width: 160px;
    justify-content: center;
    border-radius: 0 4px 4px 0;
    -webkit-border-radius: 0 4px 4px 0;
    -moz-border-radius: 0 4px 4px 0;
    -ms-border-radius: 0 4px 4px 0;
    -o-border-radius: 0 4px 4px 0;
}
</style>